
import { Injectable } from '@angular/core';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { AppState } from '../app-state';
import { ScoutTaskService } from './scout-task.service';
import { ScoutPointRefDialogComponent } from '../../scout/scout-point/scout-point-ref-dialog/scout-point-ref-dialog.component';

@Injectable({ providedIn: 'root' })
export class ScoutPointRefLauncher {

    constructor(
        private appState: AppState,
        public scoutTaskService: ScoutTaskService,
        private modalService: BsModalService
    ){}

    showScoutPointRefData = async ( criteria: { buildingId: string, pathId: string, pointId: string, stage?: string }) => {
        const { buildingId, pathId, pointId, stage } = criteria
        console.log(`showScoutPointRefData(${pointId})`)
        const pathNumber = parseInt(pathId?.replace(/^.*P[0]+/,''))
        if ( !pathNumber ) {
          this.appState.notifyWarning(
            `Could not resolve path# for point "${pointId}" (path: "${pathId||''}")`,this,5)
          return
        }
        let scoutTasks =  await this.scoutTaskService.rxCollection.find()
          .where('buildingId').eq(buildingId).where('scoutPaths').elemMatch({pathNumber: pathNumber}).exec()
        if ( !scoutTasks.length ) {
          this.appState.notifyWarning(
            `Could not find a scout for building "${buildingId}" and path "${pathNumber}"`,this,5)
          return
        }
        const stageScoutTasks = scoutTasks.filter(scout=>!stage || scout.stage==stage )
        if ( stageScoutTasks.length > 0 ) {
          scoutTasks = stageScoutTasks
        }
        if ( scoutTasks.length > 1 ) {
          this.appState.notifyWarning(
            `Multiple scouts found for building "${buildingId}" and path "${pathNumber}"`,this,10)
          return
        }
        const scoutTask = scoutTasks[0]
        const scoutPaths = scoutTask.scoutPaths.filter(sp=>sp.pathNumber==pathNumber)
        if ( scoutPaths.length != 1 ) {
          this.appState.notifyWarning(
            `Expected to find 1 scout path but found ${scoutPaths.length} for building "${buildingId}" and path "${pathNumber}"`,this,10)
          return
        }
        const scoutPath = scoutPaths[0]
        this.scoutTaskService.updateScoutPathContext(scoutPath,[])
        const scoutPoint = scoutPath.scoutPoints.find( sp => sp.pointId == pointId ) ||
          scoutPath.scoutPoints.find(sp=>!sp.pointId && sp.exPointId == pointId);
        if ( !scoutPoint ) {
          this.appState.notifyWarning(`Could not find Scout Point where Point ID is "${pointId}"`,this,10)
          return
        }
        const context : ModalOptions = {
          initialState: {
            scoutPointId: scoutPoint.id,
            scoutPathId: scoutPath.id,
            scoutTaskDoc: scoutTask,
            //buildingPointsSubject: this.buildingPointsSubject,
            allowEditMode: false,
            locked: true
          },
          class: 'full-screen-modal',
          id: ScoutPointRefDialogComponent.ModalId,
          animated: true,
        }
        this.modalService.show(ScoutPointRefDialogComponent, context );
      }
}